"use strict";

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var react_onclickoutside_1 = __importDefault(require("react-onclickoutside"));

var theme_1 = require("../../../styles/theme");

var Hamburger_1 = __importDefault(require("../../../icons/Hamburger"));

var NavLinks_1 = __importDefault(require("./NavLinks"));

var Sidebar_1 = __importDefault(require("./Sidebar"));

var HorizontalFlexContainer = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  box-sizing: border-box;\n  align-items: center;\n  font-family: 'DM Sans', sans-serif;\n  padding: 1em 1.5em;\n  display: flex;\n  width: 100%;\n\n  ", " {\n    & > a:not(:first-of-type) {\n      display: none;\n    }\n  }\n"], ["\n  background-color: white;\n  box-sizing: border-box;\n  align-items: center;\n  font-family: 'DM Sans', sans-serif;\n  padding: 1em 1.5em;\n  display: flex;\n  width: 100%;\n\n  ", " {\n    & > a:not(:first-of-type) {\n      display: none;\n    }\n  }\n"])), theme_1.theme.breakpoints.tabletLandscapeDown);
var Burger = styled_1["default"](Hamburger_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: none;\n  height: 1.5em;\n  margin-left: auto;\n  width: 1.5em;\n\n  ", " {\n    display: inline-block;\n  }\n"], ["\n  cursor: pointer;\n  display: none;\n  height: 1.5em;\n  margin-left: auto;\n  width: 1.5em;\n\n  ", " {\n    display: inline-block;\n  }\n"])), theme_1.theme.breakpoints.tabletLandscapeDown);
var TrackComponentName = 'Header';

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClickOutside = function () {
      _this.setState({
        isMobileExpanded: false
      });
    };

    _this.toggleHamburgerMenu = function () {
      _this.setState({
        isMobileExpanded: !_this.state.isMobileExpanded
      });
    };

    _this.setSidebarVisible = function (visible) {
      _this.setState({
        isMobileExpanded: visible
      });
    };

    _this.state = {
      isMobileExpanded: false
    };
    return _this;
  }

  Header.prototype.render = function () {
    var track = this.props.track;
    return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(HorizontalFlexContainer, null, react_1["default"].createElement(Sidebar_1["default"], {
      headerHeight: 48,
      track: track,
      setSidebarVisible: this.setSidebarVisible,
      show: this.state.isMobileExpanded,
      key: "sidebar"
    }), react_1["default"].createElement(NavLinks_1["default"], {
      track: track,
      trackComponentName: TrackComponentName,
      setSidebarVisible: this.setSidebarVisible
    }), react_1["default"].createElement(Burger, {
      onClick: this.toggleHamburgerMenu
    })));
  };

  return Header;
}(react_1["default"].Component);

var clickOutsideConfig = {
  handleClickOutside: function handleClickOutside(instance) {
    return instance.handleClickOutside;
  }
};
exports["default"] = react_onclickoutside_1["default"](Header, clickOutsideConfig);
var templateObject_1, templateObject_2;